import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import types from 'utils/prop-types';
import api from 'utils/api';
import constants from 'utils/constants';
import { ToTitleCase } from 'utils/strings';
import { logout } from 'ducks/modules/user';
import { clearSelectedMessage } from 'ducks/modules/messages';
import 'components/search-preview/search-preview.scss';
import { getWorkUrl } from '../../utils/works';

class SearchPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            open: false,
            index: -1,
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
    }

    handleKeyDown(e) {
        if (this.state.open) {
            switch (e.keyCode) {
                case 38: // up arrow
                    if (this.state.index > 0) {
                        this.setState({ index: this.state.index - 1 });
                    }
                    break;
                case 40: // down arrow
                    if (this.state.results.length - 1 > this.state.index) {
                        this.setState({ index: this.state.index + 1 });
                    }
                    break;
                case 27: // escape
                    this.setState({ open: false, index: -1 });
                    break;
                default:
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
        document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    }

    UNSAFE_componentWillUpdate(props, state) {
        if (this.state.results !== state.results) {
            this.props.onChange(state.results);
        }
        if (this.state.index !== state.index) {
            this.props.onIndexChanged(state.index);
        }
    }

    handleClickOutside(e) {
        if (this.self && !this.self.contains(e.target)) {
            this.setState({
                open: false,
                index: -1,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.input === '') {
            this.setState({ open: false });
        } else if (this.props.input !== props.input) {
            this.setState({ open: true }, () => this.search(props));
        }
    }

    async search(props) {
        if (!props) {
            props = this.props;
        }
        try {
            // 'ipi' needs to be expanded into 'writers_ipi' and 'publishers_ipi' fields for elastic
            const fields = _.flatten(
                constants.SearchFilters.map((field) => (field === 'ipi' ? ['writers_ipi', 'publishers_ipi'] : field)),
            );

            // search with elastic
            const response = await api.searchWorks(0, 5, {
                query: props.input,
                filter: 'any',
                fields,
                autocomplete: true,
            });

            this.setState({
                index: -1,
                results: response.data,
            });
        } catch (err) {
            console.error('Error fetching search results: ', err);
            if (err && err.status === constants.HttpCodes.UNAUTHORIZED) {
                props.logout(err.data === constants.ServerCodes.TOKEN_EXPIRED);
            }
        }
    }

    render() {
        return (
            <div
                ref={(ref) => (this.self = ref)}
                className={`bk-search-preview ${this.state.open ? 'open' : ''} ${this.props.className}`}>
                <ul className={this.state.index !== -1 ? 'active-index' : ''}>
                    {this.state.results
                        .map((result) => result._source)
                        .map((work, i) => (
                            <li key={`result-${i}`}>
                                <Link
                                    onMouseEnter={() => this.setState({ index: -1 })}
                                    className={this.state.index === i ? 'highlighted' : ''}
                                    to={getWorkUrl(work.bk_work_id)}
                                    onClick={() => this.setState({ open: false }, this.props.clearSelectedMessage)}>
                                    <p>{ToTitleCase(work.title)}</p>
                                    <p>{Array.isArray(work.writers) ? _.uniq(work.writers).join(' \u2022 ') : '-'}</p>
                                    <p>
                                        {Array.isArray(work.artist_names)
                                            ? _.uniq(work.artist_names).slice(0, 3).join(' \u2022 ')
                                            : '-'}
                                    </p>
                                </Link>
                            </li>
                        ))}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    logout: PropTypes.func,
});

const mapDispatchToProps = (dispatch) => ({
    logout: (tokenExpired) => dispatch(logout(tokenExpired)),
    clearSelectedMessage: () => dispatch(clearSelectedMessage()),
});

SearchPreview.propTypes = {
    user: types.user,
    onChange: PropTypes.func, // function to invoke with update input field value
    onIndexChanged: PropTypes.func,
    input: PropTypes.string, // value of input field
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPreview);
